/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantActivationDetailsV3 { 
    activated_by?: string;
    activation_group_id?: string;
    activation_task_id?: string;
    activation_timestamp?: Date;
    cb_pop_id?: string;
    deactivation_request_urn?: string;
    deactivation_requested_by?: string;
    deactivation_requested_task_id?: string;
    deactivation_requested_timestamp?: Date;
    is_region_enabled?: boolean;
    org_country_code?: string;
    org_id?: string;
    org_key?: string;
    ransomware_recovery_deployment_id?: string;
    region_id?: string;
    request_urn?: string;
    requested_by?: string;
    requested_timestamp?: Date;
    cb_child_org_id?: number;
    deployment_version?: TenantActivationDetailsV3.DeploymentVersionEnum;
}
export namespace TenantActivationDetailsV3 {
    export type DeploymentVersionEnum = 'V2' | 'V3';
    export const DeploymentVersionEnum = {
        V2: 'V2' as DeploymentVersionEnum,
        V3: 'V3' as DeploymentVersionEnum
    };
}


